import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { InctvClaimLineList } from '@/sc/entities/inctvClaimLine/InctvClaimLineList';
import { useCallback } from 'react';
import { TitleButton } from '@/common/buttons/TitleButton';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

export const InctvClaimDetail = () => {

  const { entityObj } = useEntityMgr();
  const rsrc = useRsrc();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'distClaimLine', label: 'Lines', content: <InctvClaimLineList inctvClaimObj={entityObj} /> },
  ];

  const pay = () => {
    const req = {
      entity: 'INCTV_CLAIM',
      pluginCode: 'INCTV_CLAIM_PAY_ACTION_PLUGIN'
    }

    const job = {
      name: 'Pay Incentive Claim',
      module: 'sc',
      entity: 'INCTV_CLAIM',
      entityId: entityObj.id,
      rsrcCode: 'INCTV_CLAIM_PAY_ACTION_PLUGIN',
      reqParamJson: JSON.stringify(req),
      cat: 'ACTION'
    }

    rsrc.save('skdr', 'JOB', job).then(job => {
      rsrc.start(job.id)
    })
  }

  const augButtons = useCallback((buttons) => {
        if (entityObj.status !== 'PAID') {
          buttons.push(<TitleButton dataTestId={'pay-button'} icon={fas.faDollarSign} toolTip="Pay" onClick={pay} />);
        }
      }, [entityObj.status]);

  return (
    <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />
  )
}